import { Component, OnInit, Input, ViewChild, ElementRef, Inject, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { IFileStorageService } from 'src/app/core/services/api/contracts/file-storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogModalComponent, BasicModalOperationResult, IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { GuidHelper } from 'src/app/core/helpers/guid-helper';

@Component({
  selector: 'filedescriptor',
  templateUrl: './file-descriptor.component.html',
  styleUrls: ['./file-descriptor.component.scss']
})
export class FileDescriptorComponent implements OnInit {

  fileStorageBatchId: string;
  comesFromUpload: boolean = false;

  @Input()
  disabled: boolean = false;

  @Input()
  showAsRequired: boolean = true;

  @Input()
  fileDescriptorId: string;

  @Input()
  maxSize: string = "4194304";

  @Input()
  validMymeTypeFormat: string = "*";

  @Input()
  fieldLabel: string;

  @Input()
  showContent: boolean = true;

  @Input()
  fileColumnClass: string = "col-md-6";

  @Input()
  fieldPassword: string;

  @Input()
  isEncrypted: string = 'false';

  @Input()
  showPreview: boolean = true;

  fileDescriptorBase64: string;
  isImage: Boolean = false;
  fileName: string = '';
  fileContent: string;
  fileType: string;

  @Output() fileStorageBatchIdChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileDescriptorIdChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileChanging: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileChanged: EventEmitter<FileDescriptorEvent> = new EventEmitter<FileDescriptorEvent>();

  @Output()
  public onUpdateCallBack = new EventEmitter();

  constructor(
    private sanitizer: DomSanitizer,
    @Inject('IFileStorageService') private fileStorageService: IFileStorageService,
    private modalService: NgbModal) { }

  async ngOnInit() {
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.fileDescriptorId && !GuidHelper.isEmptyGuid(this.fileDescriptorId)) {
      if (this.comesFromUpload == false) {
        let fileDescriptorBase64Model = await this.fileStorageService.getBase64(this.fileDescriptorId);
        this.fileDescriptorBase64 = fileDescriptorBase64Model.base64URL;
        this.fileName = fileDescriptorBase64Model.fileName;
        this.fileType = fileDescriptorBase64Model.fileType;
        this.isImage = this.fileType.indexOf("image") >= 0;
      }
    } else {
      this.fileDescriptorBase64 = null;
      this.fileName = null;
      this.fileType = null;
      this.isImage = false;
      if (this.fileDescriptorReference) {
        this.fileDescriptorReference.nativeElement.value = '';
      }
    }

    this.comesFromUpload = false;
  }

  //#region FileLoad
  @ViewChild("fileDescriptorReference") fileDescriptorReference: ElementRef;

  loadFile(event, origin) {
    switch (origin) {
      case 'fileDescriptorReference':
        if(!this.disabled)  
          (this.fileDescriptorReference.nativeElement as HTMLElement).click();
        break;
    }
  }

  async photoChange(event, origin) {
    const files = (event.target as HTMLInputElement).files;
    const reader = new FileReader();
    this.fileName = files[0].name;
    this.fileType = files[0].type;
    this.isImage = this.fileType.indexOf("image") >= 0;

    let hasMoreThanOneFormat = this.validMymeTypeFormat.split(",").length > 1;
    let formatContainsAll = this.validMymeTypeFormat.indexOf("*") > 0;

    if (this.isEncrypted == "true" && this.fileType != '') {
      const modalInstance = this.modalService.open(DialogModalComponent).componentInstance as IBasicModalComponentInstance;
      modalInstance.title = "Error";
      modalInstance.body = `El archivo seleccionado no es un archivo encriptado.`;
      modalInstance.type = BasicModalOperationResult.Error;

      this.fileDescriptorBase64 = null;
      this.fileDescriptorId = null;
      this.fileDescriptorReference.nativeElement.value = '';
      this.fileName = "";

      return;
    }

    if (this.validMymeTypeFormat != "*") {
      if ((hasMoreThanOneFormat && this.validMymeTypeFormat.indexOf(this.fileType) < 0) ||
        (formatContainsAll && this.validMymeTypeFormat.split("/")[0] != this.fileType.split("/")[0]) ||
        (!formatContainsAll && !hasMoreThanOneFormat && this.validMymeTypeFormat !== this.fileType)) {
        const modalInstance = this.modalService.open(DialogModalComponent).componentInstance as IBasicModalComponentInstance;
        modalInstance.title = "Error";
        modalInstance.body = `El archivo seleccionado no se corresponde con el tipo especificado.`;
        modalInstance.type = BasicModalOperationResult.Error;

        this.fileDescriptorBase64 = null;
        this.fileDescriptorId = null;
        this.fileDescriptorReference.nativeElement.value = '';
        this.fileName = "";

        return;
      }
    }

    if (files[0].size > Number(this.maxSize)) {
      let maxAllowedSize = Number(this.maxSize) / 1024 / 1024;
      const modalInstance = this.modalService.open(DialogModalComponent).componentInstance as IBasicModalComponentInstance;
      modalInstance.title = "Error";
      modalInstance.body = `El archivo seleccionado supera el límite máximo de ${maxAllowedSize} MB.`;
      modalInstance.type = BasicModalOperationResult.Error;

      this.fileDescriptorBase64 = null;
      this.fileDescriptorId = null;
      this.fileDescriptorReference.nativeElement.value = '';
      this.fileName = "";

      return;
    }

    this.fileChanging.emit();
    switch (origin) {
      case 'fileDescriptorReference':
        reader.onload = async () => {

          this.fileDescriptorBase64 = reader.result as string;

          if (this.fileDescriptorId) {
            await this.fileStorageService.removeTempFile(this.fileDescriptorId);
          }

          let batchId = this.fileStorageBatchId ? this.fileStorageBatchId : null;
          let tempFileDescriptors = [];

          if (this.fieldPassword && this.fieldPassword != '') {
            tempFileDescriptors = await this.fileStorageService.upload(files, batchId, this.fieldPassword);
          } else {
            tempFileDescriptors = await this.fileStorageService.upload(files, batchId, null, this.isEncrypted);
          }

          this.setBatchId(tempFileDescriptors[0].batchId);
          this.fileDescriptorId = tempFileDescriptors[0].id;
          this.fileDescriptorIdChange.emit(this.fileDescriptorId);
          this.fileStorageBatchIdChange.emit(this.fileStorageBatchId);
          this.fileChanged.emit({ batchId: this.fileStorageBatchId });
          this.comesFromUpload = true;
          this.onUpdateCallBack.emit();
        }
        break;
    }

    reader.readAsDataURL(files[0]);
  }

  async showFilePreview() {
    this.prepareContentAndShowPreview();
  }

  prepareContentAndShowPreview() {
    var blobFront = this.base64toBlob(this.fileDescriptorBase64, this.fileType);
    let fileContent = URL.createObjectURL(blobFront);
    window.open(fileContent, 'blank');
  }

  base64toBlob(base64Data: string, contentType: string) {
    let base64result = base64Data.split(',')[1];
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64result);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  setBatchId(batchId: string) {
    this.fileStorageBatchId = batchId;
  }

  cleanURL(oldURL): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }
}

export class FileDescriptorEvent {
  batchId: string;
}
